// Color determinista por etiqueta de propietario.
// La etiqueta especial "Importado" mapea al color del tema (null → fallback en main).

// Paleta de rutas del sistema Fanzine (dirección de arte, daltónico-segura).
export const OWNER_PALETTE = [
  '#ff3d9a', // rosa flúor (tinta 1)
  '#2e5be6', // azul tinta (tinta 2)
  '#ffc94b', // ámbar
  '#34d1c4', // teal
  '#ff5630', // rojo
  '#9b6bff', // violeta
  '#2bb36a', // verde
];

export const IMPORTED_LABEL = 'Importado';

export function ownerColor(label) {
  if (!label || label === IMPORTED_LABEL) return null;
  let h = 0;
  for (let i = 0; i < label.length; i++) h = (h * 31 + label.charCodeAt(i)) | 0;
  return OWNER_PALETTE[Math.abs(h) % OWNER_PALETTE.length];
}

export function uniqueOwners(tracks) {
  const set = new Map();
  for (const t of tracks) {
    const label = t.ownerLabel || IMPORTED_LABEL;
    set.set(label, (set.get(label) || 0) + 1);
  }
  return [...set.entries()].map(([label, count]) => ({
    label,
    count,
    color: ownerColor(label),
  }));
}
